import { createMessages as _createMessages } from '@play-co/replicant';
import stateSchema from './schema';

export const createMessages = _createMessages(stateSchema, {
  // Uncommenting this breaks the Replicant config because reasons
  // ruleset,
});
